import React from "react";
import { InboxOutlined, ArrowLeftOutlined } from "@ant-design/icons";

// The single entry point between the Active roster and the Deactivated "bin".
//
// Active/Deactivated is a filter *within* the User list, not a peer of the
// primary view tabs (User List / Market View / API Keys) — so instead of a
// second toggle row that competes with those pills, the active view carries one
// count-bearing "Deactivated N" chip (a distinct object, not a toggle), and the
// deactivated view carries a "Back to active users" link. Keeps a single toggle
// on the page while the count keeps the bin discoverable.
export const DeactivatedEntry = ({ statusFilter, deactivatedCount = 0, onChange }) => {
  if (statusFilter === "deactivated") {
    return (
      <button
        type="button"
        onClick={() => onChange("active")}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          fontFamily: "Inter, sans-serif",
          fontSize: 14,
          fontWeight: 500,
          color: "#0e49b5",
          background: "transparent",
          border: "none",
          cursor: "pointer",
          padding: "6px 4px",
        }}
      >
        <ArrowLeftOutlined aria-hidden="true" />
        Back to active users
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={() => onChange("deactivated")}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        fontFamily: "Inter, sans-serif",
        fontSize: 14,
        fontWeight: 500,
        color: "#3f3f46",
        background: "#fff",
        border: "0.5px solid rgba(0, 0, 0, 0.15)",
        borderRadius: 9999,
        cursor: "pointer",
        padding: "6px 14px",
      }}
    >
      <InboxOutlined aria-hidden="true" />
      Deactivated
      <span
        style={{
          background: "#F0F2F5",
          color: "#3f3f46",
          borderRadius: 9999,
          padding: "1px 8px",
          fontSize: 12,
          fontWeight: 500,
        }}
      >
        {deactivatedCount}
      </span>
    </button>
  );
};
